export const categories = [
  { slug: 'mingxing-heiliao', name: '明星黑料', icon: 'ri-star-line', description: '明星艺人最新黑料曝光汇总' },
  { slug: 'wanghong-fanche', name: '网红翻车', icon: 'ri-live-line', description: '网红主播翻车事件全记录' },
  { slug: 'yiren-chouwen', name: '艺人丑闻', icon: 'ri-alert-line', description: '娱乐圈艺人丑闻内幕揭秘' },
  { slug: 'dujia-neimu', name: '独家内幕', icon: 'ri-eye-line', description: '独家内幕一手爆料抢先看' },
];

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  coverImage: string;
  publishedAt: string;
  author: string;
  tags: string[];
  views: number;
  isHot: boolean;
  isNew: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '顶流男星深夜私会神秘女子，酒店密会五小时被拍',
    excerpt: '据知情人士透露，某当红顶流男星深夜被拍到与一名神秘女子先后进入某五星级酒店，两人在酒店内密会长达五小时后才先后离开，全程被狗仔抓拍到高清画面。',
    content: `<p>近日，娱乐圈又爆出一则重磅消息。据知情人士透露，某当红顶流男星深夜被拍到与一名神秘女子先后进入某五星级酒店，两人在酒店内密会长达五小时后才先后离开。</p>
    <p>据悉，该男星当天刚结束一场商业活动，本应返回住处休息，却在中途让司机绕道前往了该酒店。大约半小时后，一位身穿黑色长裙、戴着口罩和墨镜的女子也进入了同一家酒店。</p>
    <p>更值得注意的是，该男星此前一直在公开场合维持"单身人设"，多次在采访中表示自己专注事业、暂无恋爱打算。这次密会事件的曝光，无疑给他的形象带来了极大的冲击。</p>
    <p>有圈内人士透露，这位神秘女子疑似某知名模特，两人此前曾在某时尚活动上有过交集。不过目前双方团队均未对此事做出回应。</p>
    <p>该事件一经曝光，迅速登上各大社交平台热搜榜首。粉丝群体出现了严重的分裂——一部分粉丝表示"相信哥哥，等官方回应"，另一部分粉丝则表示"脱粉了，被骗了这么多年"。</p>
    <p>业内人士分析认为，如果该爆料属实，不仅会影响该男星的商业价值，还可能导致其正在洽谈的多个代言和影视项目出现变数。目前多个品牌方已经开始密切关注此事的进展。</p>`,
    category: 'mingxing-heiliao',
    categoryName: '明星黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20with%20paparazzi%20flash%20lights%2C%20mysterious%20silhouette%20figures%2C%20dark%20atmosphere%20with%20warm%20street%20lamp%20glow%2C%20cinematic%20lighting%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20film%20noir%20aesthetic&width=800&height=500&seq=chigua-article-1&orientation=landscape',
    publishedAt: '2026-08-05',
    author: '吃瓜小编',
    tags: ['顶流男星', '密会', '酒店', '单身人设'],
    views: 128500,
    isHot: true,
    isNew: true,
  },
  {
    id: 'article-2',
    title: '知名女网红带货翻车！声称"纯天然"产品被曝含违禁成分',
    excerpt: '拥有千万粉丝的美妆网红在直播间大力推荐的一款"纯天然美白丸"，近日被第三方检测机构查出含有多种违禁成分，长期使用可能导致肝肾功能损伤。',
    content: `<p>拥有超过千万粉丝的知名美妆网红"小仙女CC"，近日因带货产品翻车而陷入舆论漩涡。其在直播间大力推荐的一款号称"纯天然、无添加"的美白丸，被第三方权威检测机构查出含有多种违禁药物成分。</p>
    <p>据检测报告显示，该产品中含有激素类成分和重金属超标问题，长期服用可能导致肝肾功能损伤、内分泌失调等严重后果。已经有消费者反映在服用后出现头晕、恶心等症状。</p>
    <p>更令粉丝愤怒的是，"小仙女CC"在直播中曾多次强调自己"亲自试用过、效果非常好"，甚至晒出了所谓的"检测报告"来证明产品的安全性。然而事后被证实该检测报告系伪造。</p>
    <p>事件发酵后，该网红先是删除了所有相关带货视频，随后发布了一则道歉声明，称自己也是"被厂家欺骗"，并表示愿意配合调查。但这并未平息粉丝的怒火。</p>
    <p>目前，市场监管部门已经介入调查，多个电商平台已下架该产品。该网红的多个商业合作品牌也纷纷宣布终止合作，其社交账号粉丝数量在三天内跌去近200万。</p>
    <p>这一事件再次引发了公众对网红带货监管的关注。有法律专家指出，网红作为产品的推荐者，应当对所推荐产品的质量和安全性承担相应的法律责任。</p>`,
    category: 'wanghong-fanche',
    categoryName: '网红翻车',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beauty%20product%20livestream%20setup%20with%20skincare%20bottles%20and%20mirrors%2C%20dramatic%20lighting%2C%20warm%20makeup%20studio%20background%20with%20ring%20light%2C%20product%20photography%20style%20with%20soft%20shadows%2C%20clean%20aesthetic%20composition&width=800&height=500&seq=chigua-article-2&orientation=landscape',
    publishedAt: '2026-08-04',
    author: '吃瓜小编',
    tags: ['网红带货', '翻车', '违禁成分', '美白丸'],
    views: 96500,
    isHot: true,
    isNew: true,
  },
  {
    id: 'article-3',
    title: '某知名导演被曝片场霸凌新人演员，多名工作人员实名举报',
    excerpt: '一位曾获多项大奖的知名导演被剧组多名工作人员实名举报，指控其在片场对新人演员进行言语侮辱和身体推搡，甚至要求演员在极度危险的情况下反复拍摄危险镜头。',
    content: `<p>娱乐圈再次爆出令人震惊的片场霸凌事件。一位曾获得多项国内外大奖的知名导演，近日被剧组多名工作人员实名举报，指控其在拍摄过程中对新人演员实施霸凌行为。</p>
    <p>据举报材料显示，该导演在片场经常对新人演员进行言语侮辱，用极其难听的词语评价演员的表演。更有甚者，在一次动作戏的拍摄中，该导演不顾安全指导的建议，坚持要求演员在没有任何保护措施的情况下反复拍摄危险镜头。</p>
    <p>一位不愿透露姓名的剧组人员表示："那个新人演员当时已经明显体力不支了，但导演就是不让停，一直骂他是'废物'、'不配当演员'。最后那个演员是被抬下片场的。"</p>
    <p>此外，该导演还被指控利用职务之便对女演员进行不当接触和暗示。有女演员表示，导演曾以"讨论剧本"为由单独约见，期间多次做出不当举动。</p>
    <p>这些举报材料已经在业内引起轩然大波。多家影视公司表示将暂停与该导演的合作，其正在筹备的新片项目也面临搁浅的风险。</p>
    <p>目前，相关行业协会已经表示将对此事展开调查。业内人士呼吁，影视行业亟需建立完善的片场权益保护机制，不能让权力成为霸凌的工具。</p>`,
    category: 'yiren-chouwen',
    categoryName: '艺人丑闻',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20professional%20camera%20equipment%20and%20lighting%20rigs%2C%20dramatic%20moody%20atmosphere%2C%20dark%20cinematic%20lighting%20with%20shadows%2C%20behind%20the%20scenes%20movie%20production%20aesthetic%2C%20tense%20atmosphere&width=800&height=500&seq=chigua-article-3&orientation=landscape',
    publishedAt: '2026-08-03',
    author: '吃瓜小编',
    tags: ['导演', '片场霸凌', '新人演员', '实名举报'],
    views: 87300,
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-4',
    title: '独家：某女星与富商老公已秘密离婚，财产分割达九位数',
    excerpt: '据圈内可靠消息源透露，某知名女星与结婚五年的富商老公已于上月秘密办理离婚手续，两人涉及的财产分割金额高达九位数，其中包括多处豪宅和公司股权。',
    content: `<p>据圈内多位可靠消息源向本平台独家透露，某知名一线女星与其富商老公已于上月在海外秘密办理了离婚手续。两人五年的婚姻就此画上句号，而涉及的财产分割问题更是引起了广泛关注。</p>
    <p>据悉，该女星与富商老公在五年婚姻期间共同积累了巨额财富，包括位于北京、上海、香港、洛杉矶等地的多处豪宅，以及多家公司的股权。初步估算，此次财产分割的总金额高达九位数。</p>
    <p>消息人士透露，两人实际上在半年前就已经开始分居。离婚的原因据称是双方在事业发展方向上产生了严重分歧——女星希望继续在演艺圈发展，而富商则希望她能够淡出娱乐圈，更多地照顾家庭。</p>
    <p>值得注意的是，两人在结婚时并未签署婚前协议，这导致离婚时的财产分割变得异常复杂。据称双方律师团队已经就财产分配问题进行了长达数月的谈判。</p>
    <p>目前，该女星的社交账号上已经清空了所有与富商老公相关的合影和动态。其工作室对离婚传闻的回应是"艺人的私人事务不便回应"，这一模棱两可的表述似乎从侧面印证了传闻的真实性。</p>
    <p>圈内人士分析，该女星在离婚后可能会更加专注于事业，目前已经有多个大制作项目在接洽中。</p>`,
    category: 'dujia-neimu',
    categoryName: '独家内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20luxurious%20modern%20mansion%20interior%20with%20marble%20floors%20and%20chandeliers%2C%20elegant%20but%20somber%20atmosphere%2C%20soft%20warm%20lighting%2C%20high-end%20real%20estate%20photography%2C%20subtle%20melancholy%20mood&width=800&height=500&seq=chigua-article-4&orientation=landscape',
    publishedAt: '2026-08-03',
    author: '吃瓜小编',
    tags: ['女星', '离婚', '财产分割', '富商'],
    views: 112000,
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-5',
    title: '综艺节目后台冲突曝光！两位导师因选手意见大打出手',
    excerpt: '某热门选秀综艺录制现场发生严重冲突，两位明星导师因对选手的评分意见不合，在后台休息室爆发激烈争吵，甚至演变为肢体冲突，导致节目录制被迫中断。',
    content: `<p>综艺节目的后台远比镜头前精彩。据现场工作人员爆料，某热门选秀综艺在最新一期录制过程中，两位明星导师因对一位选手的评分产生严重分歧，在后台休息室爆发了激烈冲突。</p>
    <p>知情人士描述，当时一位导师认为该选手表现优异应当晋级，而另一位导师则强烈反对，认为其"毫无天赋"。两人从观点分歧逐渐升级为人身攻击，最终竟然演变为肢体冲突。</p>
    <p>"当时现场所有人都惊呆了，"一位现场工作人员回忆道，"两位平时在镜头前温文尔雅的导师，在后台完全变了个人。茶几都被掀翻了，化妆师吓得躲到了角落里。"</p>
    <p>节目组工作人员花了将近半小时才将两人分开。冲突导致了节目录制被迫中断近两个小时。节目组随后紧急召开了内部会议，讨论如何处理这一突发事件。</p>
    <p>目前，该综艺节目的官方账号尚未对此事做出回应。但据传节目组正在考虑是否需要在后续节目中更换其中一位导师。</p>
    <p>这一事件在业内引起了广泛讨论。有制作人表示，选秀节目中导师之间的意见分歧很正常，但演变为肢体冲突确实罕见，也从侧面反映出当前综艺节目在导师管理和情绪引导方面存在不足。</p>`,
    category: 'yiren-chouwen',
    categoryName: '艺人丑闻',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20backstage%20area%20with%20makeup%20mirrors%20and%20lighting%20equipment%2C%20messy%20and%20chaotic%20aftermath%20scene%2C%20dramatic%20lighting%2C%20reality%20show%20behind%20the%20scenes%20aesthetic%2C%20tense%20atmosphere&width=800&height=500&seq=chigua-article-5&orientation=landscape',
    publishedAt: '2026-08-02',
    author: '吃瓜小编',
    tags: ['综艺', '导师冲突', '选秀', '后台'],
    views: 74500,
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-6',
    title: '千万粉丝网红被曝学历造假，名校毕业证竟是PS的',
    excerpt: '一位以"学霸人设"走红的网红近日被网友扒出学历造假，其声称的某985名校毕业证经查证系伪造。该网红此前一直以"名校学姐"身份给粉丝分享学习方法。',
    content: `<p>网红圈又出"学历门"事件。一位以"学霸人设"走红、拥有超千万粉丝的知名网红，近日被网友扒出学历造假——其一直声称的某985名校毕业证书，经仔细查证系伪造。</p>
    <p>该网红自出道以来，一直以"名校学姐"的人设吸引粉丝，经常在视频中分享所谓的"高效学习方法"和"名校生存指南"。其个人简介中赫然写着"XX大学硕士毕业"，而这正是其吸粉的核心卖点之一。</p>
    <p>然而，有细心的网友在查阅该大学历年毕业生名单后发现，根本没有该网红的名字。更进一步的调查发现，其晒出的毕业证书上存在多处PS痕迹——校徽位置偏移、字体不一致、公章模糊等问题十分明显。</p>
    <p>事件曝光后，该网红先是删除了所有与"学历"相关的视频和动态，随后发布了一则含糊其辞的回应，称自己"确实在该校学习过"，但避而不谈毕业证书的问题。</p>
    <p>这一事件引发了粉丝群体的强烈反应。许多粉丝表示受到了欺骗："我们是因为相信她是名校学姐才关注她的，结果全是假的。"</p>
    <p>业内人士指出，近年来网红"翻车"事件频发，"人设造假"已经成为行业的普遍问题。平台方应当加强对网红身份信息的审核，而网红自身也应该意识到，诚信才是长久发展的根基。</p>`,
    category: 'wanghong-fanche',
    categoryName: '网红翻车',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20study%20desk%20with%20diploma%20documents%20and%20graduation%20certificates%20scattered%2C%20warm%20indoor%20lighting%2C%20academic%20atmosphere%2C%20slightly%20chaotic%20composition%2C%20editorial%20photography%20with%20soft%20natural%20light%20from%20window&width=800&height=500&seq=chigua-article-6&orientation=landscape',
    publishedAt: '2026-08-01',
    author: '吃瓜小编',
    tags: ['网红', '学历造假', '翻车', '人设'],
    views: 89100,
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-7',
    title: '知名男歌手被曝偷税漏税数千万，已被税务部门约谈',
    excerpt: '据可靠消息，某知名男歌手因涉嫌偷税漏税被税务部门约谈。初步调查显示，该歌手通过"阴阳合同"、虚构成本等方式逃避税款，金额或达数千万元。',
    content: `<p>娱乐圈税务问题再次成为焦点。据可靠消息源透露，某知名男歌手因涉嫌偷税漏税，已于近日被税务部门正式约谈。初步调查显示，涉案金额或高达数千万元。</p>
    <p>据了解，该歌手在过去的几年中频繁使用"阴阳合同"的方式来规避高额税款。具体操作方式为：对外签署一份金额较小的合同用于报税，而实际履行的则是另一份金额远高于此的合同。</p>
    <p>此外，调查人员还发现该歌手通过虚构成本支出、虚列费用等方式来降低应纳税所得额。这些操作涉及多个关联公司和工作室，形成了一个复杂的避税网络。</p>
    <p>目前，税务部门已经掌握了大量证据材料。如果最终认定偷税漏税行为成立，该歌手不仅需要补缴税款和滞纳金，还可能面临数倍的罚款，甚至刑事责任。</p>
    <p>这一消息在业内引起了强烈震动。多位艺人经纪人表示已经开始自查税务状况，以确保合规。近年来，随着税务监管力度的不断加大，娱乐圈的税务合规问题已经成为了悬在艺人头顶的"达摩克利斯之剑"。</p>
    <p>该歌手的经纪团队目前尚未对此事做出公开回应，其原定于下月举行的巡回演唱会能否如期举办也成了未知数。</p>`,
    category: 'mingxing-heiliao',
    categoryName: '明星黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20serious%20office%20scene%20with%20financial%20documents%20and%20tax%20forms%20on%20a%20desk%2C%20calculators%20and%20stamps%2C%20dramatic%20side%20lighting%2C%20corporate%20investigation%20aesthetic%2C%20dark%20wood%20furniture%2C%20tense%20professional%20atmosphere&width=800&height=500&seq=chigua-article-7&orientation=landscape',
    publishedAt: '2026-08-01',
    author: '吃瓜小编',
    tags: ['男歌手', '偷税漏税', '阴阳合同', '约谈'],
    views: 105200,
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-8',
    title: '独家内幕：某选秀节目冠军内定黑幕大揭秘',
    excerpt: '据节目组内部人员爆料，某大型选秀节目的冠军早在海选阶段就已内定。节目组与经纪公司之间存在复杂的利益输送关系，观众看到的"公平竞争"全是精心设计的剧本。',
    content: `<p>选秀节目的"公平公正"口号背后，究竟隐藏着怎样的真相？本平台获得节目组内部人士的独家爆料，揭秘某大型选秀节目冠军内定的惊人黑幕。</p>
    <p>据该内部人士透露，节目的冠军人选早在海选阶段就已经基本确定。这位"天选之子"来自一家与节目制作方有深度合作的经纪公司，双方早在节目筹备阶段就达成了利益输送协议。</p>
    <p>"比赛的每一个环节都是精心设计的，"该内部人士表示，"包括谁在什么时候晋级、谁在什么时候被淘汰、谁和谁产生冲突制造话题，全都在剧本里写得清清楚楚。观众看到的'逆袭'、'爆冷'，其实都是设计好的。"</p>
    <p>更令人震惊的是，所谓的"观众投票"也并非完全真实。节目组会通过技术手段对票数进行"合理调整"，确保最终的排名符合预定的剧本。而那些真正有实力但没有"背景"的选手，往往在早期就被淘汰。</p>
    <p>该爆料还指出，节目组的导师们在某种程度上也是"配合演出"。虽然导师们确实会在专业上给出意见，但在关键的晋级决定上，最终还是以节目组的安排为准。</p>
    <p>这一爆料的真实性目前尚无法完全证实，但已经在选秀圈引起了巨大的震动。多位曾经参加选秀但未能走红的选手在社交平台上发声，暗示自己也曾遭遇类似的不公待遇。</p>`,
    category: 'dujia-neimu',
    categoryName: '独家内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20talent%20show%20stage%20with%20dramatic%20spotlights%20and%20smoke%20effects%2C%20golden%20trophy%20in%20spotlight%2C%20dark%20background%20with%20mysterious%20atmosphere%2C%20entertainment%20industry%20aesthetic%2C%20cinematic%20lighting&width=800&height=500&seq=chigua-article-8&orientation=landscape',
    publishedAt: '2026-07-31',
    author: '吃瓜小编',
    tags: ['选秀', '内定', '黑幕', '剧本'],
    views: 135800,
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-9',
    title: '某女星产后复出被品牌方集体解约，背后原因引猜测',
    excerpt: '一位产后复出的知名女星近日遭遇品牌方集体解约，短短一周内失去了四个代言。圈内传言称这可能与其产后身材恢复状况有关，但真正的内幕远比这复杂。',
    content: `<p>产后复出对于女明星来说从来都不是一件容易的事。近日，一位知名女星在产后复出的关键时期遭遇了品牌方的集体解约，短短一周内失去了四个重要代言，引发业内广泛关注。</p>
    <p>表面上，品牌方给出的理由是"合约到期正常终止"，但四个品牌几乎在同一时间做出同样的决定，显然不是巧合。圈内流传的说法是，该女星产后身材恢复不理想，导致多个以"美丽形象"为卖点的品牌方产生了顾虑。</p>
    <p>然而，据知情人士透露，真正的原因远比这复杂。该女星的团队在产后复出规划上与品牌方产生了严重分歧——品牌方希望她能够尽快恢复到产前状态，而女星则希望有更多时间陪伴新生儿。</p>
    <p>"品牌方需要的是能够随时配合各种商业活动的艺人，而一个新手妈妈显然无法满足这种需求，"一位业内人士分析道，"更何况娱乐圈从来不缺新人，品牌方的选择很多。"</p>
    <p>该事件也再次引发了关于职场女性权益的讨论。许多网友表示，女明星产后遭遇事业困境，折射出的是整个社会对职业女性的不公待遇。</p>
    <p>目前，该女星的团队表示正在积极调整复出计划，同时也将寻求法律途径维护合法权益。</p>`,
    category: 'mingxing-heiliao',
    categoryName: '明星黑料',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fashionable%20woman%20silhouette%20against%20bright%20studio%20lights%2C%20elegant%20and%20sophisticated%20atmosphere%2C%20fashion%20photography%20backdrop%20with%20soft%20lighting%2C%20professional%20model%20portrait%20aesthetic%2C%20warm%20and%20empowering%20mood&width=800&height=500&seq=chigua-article-9&orientation=landscape',
    publishedAt: '2026-07-30',
    author: '吃瓜小编',
    tags: ['女星', '产后复出', '解约', '代言'],
    views: 56700,
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-10',
    title: '知名游戏主播直播中意外暴露涉赌聊天记录',
    excerpt: '一位拥有数百万粉丝的游戏主播在直播时不慎切换窗口，暴露了与朋友的聊天记录，其中涉及组织网络赌博的内容。虽然主播迅速关掉了窗口，但已被网友截图保存。',
    content: `<p>直播事故年年有，今年特别多。一位拥有数百万粉丝的知名游戏主播在进行日常直播时，不慎将聊天窗口展示在了直播画面中，其中包含的涉赌内容引起了轩然大波。</p>
    <p>当时该主播正在游戏间隙与观众互动，在切换窗口查看攻略时，不小心将微信聊天窗口展示在了直播画面上。虽然主播反应迅速，在两秒钟内就关掉了窗口，但这短短的两秒钟已经被眼尖的网友截图保存。</p>
    <p>截图显示，该主播在一个群聊中与朋友讨论"盘口"、"赔率"等词汇，甚至还有转账记录的截图。这些内容指向了组织或参与网络赌博的可能性。</p>
    <p>事件发酵后，该主播的直播间迅速被平台方关闭。随后，该主播发布了一则道歉声明，声称聊天内容只是朋友之间的"开玩笑"，与赌博无关。但这一解释并未获得公众认可。</p>
    <p>目前，公安机关已经对此事展开调查。如果查实该主播确实涉及组织网络赌博，将面临严重的法律后果。平台方也表示将配合调查，并根据调查结果做出进一步处理。</p>
    <p>这一事件再次提醒所有内容创作者，直播中的每一个细节都可能被无限放大，合规运营永远是第一位的。</p>`,
    category: 'wanghong-fanche',
    categoryName: '网红翻车',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gaming%20streamer%20setup%20with%20multiple%20monitors%20and%20RGB%20lighting%2C%20dark%20room%20with%20neon%20accents%2C%20gaming%20chair%20and%20headphones%2C%20streaming%20equipment%2C%20tense%20dramatic%20atmosphere%2C%20esports%20aesthetic&width=800&height=500&seq=chigua-article-10&orientation=landscape',
    publishedAt: '2026-07-29',
    author: '吃瓜小编',
    tags: ['游戏主播', '涉赌', '直播事故', '聊天记录'],
    views: 92300,
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-11',
    title: '某知名演员被曝片酬过亿却拒付剧组工作人员工资',
    excerpt: '一位片酬高达亿元的知名演员被剧组工作人员集体讨薪。据称该演员所在的制作公司拖欠了数十名剧组工作人员的工资，总额超过两百万，而该演员作为投资方之一却对此不闻不问。',
    content: `<p>片酬过亿的明星，却连工作人员的工资都不愿支付？近日，一则讨薪事件在影视圈引起了广泛关注。数十名剧组工作人员联合发声，揭露某知名演员所在的制作公司拖欠工资的真相。</p>
    <p>据悉，这数十名工作人员参与了该演员主演的一部电视剧的拍摄工作。拍摄期间一切正常，但在杀青后，制作公司以"资金周转困难"为由，迟迟未支付他们的工资，总金额超过两百万。</p>
    <p>更让讨薪者感到愤怒的是，该演员本人就是该剧的投资方之一，其个人片酬据传高达亿元。而面对工作人员的讨薪诉求，该演员却选择了不闻不问的态度。</p>
    <p>"我们辛辛苦苦工作了三个多月，每天起早贪黑，结果到现在连工资都拿不到，"一位参与讨薪的工作人员告诉记者，"而主演拿着上亿的片酬，却连我们的血汗钱都不愿意管，这太让人寒心了。"</p>
    <p>目前，讨薪者们已经向劳动监察部门投诉，并准备通过法律途径来维护自己的合法权益。有关部门表示将依法调查处理此事。</p>
    <p>这并非影视行业第一次出现讨薪事件。业内人士呼吁，行业应当建立更完善的薪酬保障机制，确保每一位从业者的劳动都能得到应有的回报。</p>`,
    category: 'yiren-chouwen',
    categoryName: '艺人丑闻',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20movie%20production%20crew%20on%20set%20with%20film%20equipment%20and%20workers%2C%20serious%20atmosphere%2C%20professional%20cinematography%20setup%2C%20outdoor%20film%20shooting%20location%2C%20documentary%20style%20photography&width=800&height=500&seq=chigua-article-11&orientation=landscape',
    publishedAt: '2026-07-28',
    author: '吃瓜小编',
    tags: ['片酬', '讨薪', '工作人员', '演员'],
    views: 48700,
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-12',
    title: '独家：两大顶流被拍同游日本，恋情疑似曝光',
    excerpt: '近日有网友在日本偶遇两位当红顶流艺人同游，两人举止亲密、形影不离。此前两人曾多次合作但一直对外宣称"只是好朋友"，此次同游被拍让恋情传闻再次甚嚣尘上。',
    content: `<p>娱乐圈又一对"好朋友"被"营业"成了真情侣？近日，有多位网友在日本东京和大阪的不同地点偶遇了两位当红顶流艺人，两人不仅同游，而且举止亲密，让人很难相信他们只是"普通朋友"。</p>
    <p>据偶遇网友描述，两人在东京银座一起逛街购物，在浅草寺一起求签祈福，在京都一起赏景拍照。全程两人有说有笑，完全没有避嫌的意思。一位网友拍到的照片显示，两人甚至手牵手走在街头。</p>
    <p>这两位艺人此前曾在多部影视作品中有过合作，荧幕CP感极强，早就被粉丝们"锁死"了。但两人对外一直坚称"只是好朋友、好搭档"，从未承认过恋情。</p>
    <p>此次日本同游被拍后，两人的粉丝群体出现了截然不同的反应。CP粉欢呼雀跃，称"终于等到了这一天"；而各自的唯粉则情绪复杂，有人祝福、有人心碎。</p>
    <p>目前，两位艺人的工作室均未对此事做出回应。但据知情人士透露，两人的团队正在紧急商讨应对策略，可能会在近期发布官方声明。</p>
    <p>圈内人士分析认为，如果两人真的确认恋爱关系，对于他们的事业来说可能是一把"双刃剑"——一方面真人CP可以为作品带来更多的关注度，但另一方面也可能会影响两人与其他演员的合作空间。</p>`,
    category: 'dujia-neimu',
    categoryName: '独家内幕',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20couple%20walking%20on%20a%20Japanese%20street%20in%20Tokyo%20at%20sunset%2C%20cherry%20blossom%20trees%2C%20warm%20golden%20hour%20lighting%2C%20traditional%20Japanese%20architecture%20background%2C%20cinematic%20romance%20aesthetic%2C%20soft%20dreamy%20atmosphere&width=800&height=500&seq=chigua-article-12&orientation=landscape',
    publishedAt: '2026-07-27',
    author: '吃瓜小编',
    tags: ['顶流', '恋情', '日本', '同游'],
    views: 156200,
    isHot: false,
    isNew: false,
  },
];